import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { EditIconComponent } from '@kuiper/icons';
import { FEATURE_FLAGS } from '../../../../../../common/constants/feature-flags.constants';
import { RequestActionEnum } from '../../../../../../common/enums/request-action.enum';
import { FeatureFlagsService } from '../../../../../../common/services/feature-flags/feature-flags.service';
import { AccordionComponent } from '../../../../../../../ui-components/lib/accordion/accordion.component';
import { AvatarComponent } from '../../../../../../../ui-components/lib/avatar/avatar.component';
import { UserDropdownViewComponent } from '../../../../../../../ui-components/lib/user-dropdown-view/user-dropdown-view.component';
import { WorkFlowStep } from '../../../workflow.model';
import { SlaTypeEnum } from '../sla-type.enum';
import { StepActionValueDirective } from './step-action-value/step-action-value.directive';

@Component({
  selector: 'lib-workflow-step-info-view',
  imports: [
    TranslocoPipe,
    AccordionComponent,
    AvatarComponent,
    NgTemplateOutlet,
    StepActionValueDirective,
    EditIconComponent,
    UserDropdownViewComponent,
  ],
  templateUrl: './workflow-step-info-view.component.html',
  styleUrl: './workflow-step-info-view.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class WorkflowStepInfoViewComponent {
  private readonly featureFlagsService = inject(FeatureFlagsService);

  stepInfo = input.required<WorkFlowStep>();
  disableExpand = input<boolean>(false);
  switchToEditMode = output<WorkFlowStep>();
  discardChanges = output();

  slaTypeEnum = SlaTypeEnum;
  requestActionsEnum = RequestActionEnum;

  readonly isAddCollaboratorsStepActionEnabled = signal(
    this.featureFlagsService.getFeatureFlagValue(
      FEATURE_FLAGS.WORKFLOW_CONFIGURATION.WORKFLOW_STEP_ACTIONS
        .add_collaborators
    )
  );

  readonly configuredStepActions = computed(
    () => this.stepInfo().step_actions ?? []
  );

  readonly hasConfiguredStepActions = computed(
    () =>
      this.isAddCollaboratorsStepActionEnabled() &&
      this.configuredStepActions().length > 0
  );

  numberOfBackSteps = computed(() => {
    return (
      this.stepInfo().actions.find(
        action => action.value === this.requestActionsEnum.SENDBACK
      )?.preference ?? 0
    );
  });

  toggleAccordion(step: WorkFlowStep) {
    if (this.disableExpand()) {
      this.discardChanges.emit();
    } else {
      step.isExpanded = !step.isExpanded;
    }
  }
}
